<template>
  <div @closeclick="cloture()">
    <a ref="lienDownload"></a>
    <div class="card modal-card-border">
      <div class="card-content">
        <div :key="index" v-for="(p, index) in marker.panneaux"
             v-if="index === marker.indexPanneauCourant" >
          <div class="columns">
            <div class="column is-11">
              <h1 class="is-5">
                <span class="subtitle">
                  Emplacement
                </span>
                <span class="title is-5">{{p.namePlace}}</span>
              </h1>
              <p class="subtitle is-7" v-if="p.codeFaces">
                Face(s) : {{p.codeFaces}}
              </p>
            </div>
          </div>
          <div class="columns detail-component">
            <div class="column is-5 is-paddingless">
              <img :src="p.urlPhoto"
                   v-if="p.urlPhoto"
                   style="max-height:220px">
              <img v-else :src="p.img">
              <br/>
              <span class="pagination-link is-current distance">{{marker.distance}} km</span>
            </div>
            <div class="column is-7 is-paddingless">
              <h1 class="subtitle is-6 information-title">Informations</h1>
              <div class="columns">
                <div class="column is-6">
                  <p class="information">Adresse commerciale</p>
                  <span>{{p.adresse1}}</span>
                  <span v-if="p.adresse2">{{p.adresse2}} </span>
                  <span v-if="p.adresse3">{{p.adresse3}} </span>
                  <span>{{p.panneauOrigine.codePostal}}</span>
                  <span>{{p.ville}}</span>
                  <br>
                  <p class="information">Format</p>
                  <span>{{p.format}}</span>
                  <br>
                  <p class="information">Matériel</p>
                  <span>{{p.materiel}}</span>
                  <br>
                  <p class="information">Restrictions</p>
                  <span>{{p.restrictions}}</span>
                  <br>
                </div>
                <div class="column is-6">
                  <p class="information">En venant de</p>
                  <span>{{p.enVenantDe}}</span>
                  <br>
                  <p class="information">En allant vers</p>
                  <span>{{p.enAllantVers}}</span>
                  <br>
                  <p class="information">Eclairé</p>
                  <span>{{p.eclaire}}</span>
                  <br>
                  <p class="information">Nombre de propositions :</p>
                  <span>{{p.nbPropositions}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-5 is-paddingless mb-10">
            <b-button type="is-primary"
                      icon-left="file-pdf"
                      expanded @click="download(p.panneauOrigine)">
              Télécharger la fiche produit
            </b-button>
          </div>
          <app-liste-affectations :panneau="p"/>
          <app-liste-opportunites :num="p.listeNumFace"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import { getFicheLc } from '@/api/PanneauxLc';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import Caracteristiques from './caracteristiques';
import ListeAffectations from './listeAffectations';
import ListeOpportunites from './listeOpportunites';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');

export default {
  name: 'info-window-map',
  props: ['marker'],
  components: {
    appCaracteristiques: Caracteristiques,
    appListeAffectations: ListeAffectations,
    appListeOpportunites: ListeOpportunites,
  },
  data() {
    return {
      niveauPasDefini: niveauDispo.DISPONIBILITE_INDEFINI,
    };
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      getPanneauxLcIsSelected: 'panneauxLcIsSelected',
      dateStart: 'dateStart',
      dateEnd: 'dateEnd',
    }),
  },
  methods: {
    ...VenteFacesLc.mapActions({
      actionsUpdateMarkerPanneau: 'updateMarkerPanneau',
    }),
    ...Panier.mapActions({
      actionsAjouterAuPanier: 'ajouterAuPanier',
    }),
    cloture() {
      this.$emit('closeInfoWindow');
    },
    async download(produit) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const response = await getFicheLc(produit);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        gestionErreur(`Erreur lors de l'impression de la fiche du panneau Lc n°${produit.num}`, e);
      }
      loadingComponent.close();
    },
  },
};

</script>

<style scoped>
.distance{
  margin-left: 0px;
  margin-top: -33px;
}

.columns{
  margin:0px;
}

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

.arrow {
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/cartographie/infoWindowMap.vue